function toAreaTypeFormatter(value: any) {
  if (value !== null && value !== undefined) {
    // Underground = 1,
    // Overhead = 2,
    // Drafting = 3,
    // Detailing = 4,
    // ProjectManagement = 5,
    switch (value) {
      case 0:
        return 'Urban';
        break;

      case 1:
        return 'Regional';
        break;

    
      default:
        return '???';
        break;
    }
    
  }
}

export default toAreaTypeFormatter;
